import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Avatar, Button, Card, Input } from 'antd';

import localFakeBlurCardsRateJSON from '../../../data/fake-blur-cards-rates.json';
import { SEARCH_BLUR_CARDS_EMAIL_LABEL_TEXT } from '../../../envVariables';
// import { isEmpty } from '../../../util/isEmpty';
import { noOfBlurCards } from '../../../util/noOfBlurCards';

const StyledCard = styled(Card)`
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
`;

const cardsRef = React.createRef();
const emailFormRef = React.createRef();

/**
 * @component
 * @category Search Page
 * @name BlurCards
 * @description It's the popup Blur Cards with blurry background component and user needs to enter email to unlock/see rate cards.
 */

class BlurCards extends Component {
  state = {
    inputEmail: '',
    topMargin: 0,
  };

  componentDidMount = () => {
    const { userEmailBlurCards } = this.props;

    // if user email is already saved before (i.e. in redux store via redux persist ), then use that email.
    this.setState({ inputEmail: userEmailBlurCards }, () => {
      this.postEmail(userEmailBlurCards);
    });

    // sets top margin
    this.setsTopMargin();
  };

  componentWillReceiveProps = (nextProps) => {
    const { parentScrollbarPosition, updatePickupDeliveryErsLine } = this.props;

    // set top margin when parent website scroll position changes
    if (parentScrollbarPosition !== nextProps.parentScrollbarPosition) {
      // console.log('next props:', nextProps.parentScrollbarPosition);
      this.setsTopMargin();
      return true;
    }

    // for uuid request, after removing old rates and adding new rates with unique id,
    // it sets top margin
    if (updatePickupDeliveryErsLine !== nextProps.updatePickupDeliveryErsLine) {
      this.setsTopMargin();
      return true;
    }

    return false;
  };

  /**
   * @description Post email to endpoint and after successfully posted it, save the email to redux store.
   * <br> <br>
   * **postEmail(emailStr) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | emailStr      | string        | User need to enter email|

   * Returns: Type: void
   *
   * @example
   * postEmail("test@t"); //it returns because it's not a valid email
   */
  postEmail = (emailStr) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = re.test(emailStr);
    // console.log({ isValid });

    if (!isValid) {
      this.props.updateErrorAndLoading('input a valid email', undefined);
      return;
    }

    //send email to remote endpoint
    this.props.postUserEmailBlurCards(emailStr);
  };

  /**
   * @description When user press Enter or click on Submit button after typing email
   * <br> <br>
   * **onEnterClick() -> {void}**
   * <br> <br>
   * Returns: Type: void
   */
  onEnterClick = () => {
    const { inputEmail } = this.state;
    // const inputEmail = e.target.value;

    if (!inputEmail.trim()) {
      console.log('empty email field');
      return;
    }

    this.postEmail(inputEmail);
  };

  /**
   * @description When user type into email field
   * <br> <br>
   * **onInputChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Mouse event  |
   * <br> <br>
   * Returns: Type: void
   */
  onInputChange = (e) => {
    this.setState({ inputEmail: e.target.value });
  };

  /**
   * @description It sets the top margin to popup blur cards component.
   * <br> <br>
   * **setsTopMargin() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  setsTopMargin = () => {
    const { parentScrollbarPosition } = this.props;

    const cardsHt = (cardsRef.current || {}).clientHeight;
    const emailFormHt = (emailFormRef.current || {}).clientHeight || 120;

    //one card is height is 264px, marginBottom is 15 px
    //so one card ht = 279px

    const minTopMargin = (279 - emailFormHt) / 2;
    const maxTopMargin = cardsHt - emailFormHt;

    let totalTopMargin = parentScrollbarPosition;

    totalTopMargin =
      totalTopMargin < minTopMargin ? minTopMargin : totalTopMargin;

    totalTopMargin =
      totalTopMargin >= maxTopMargin ? maxTopMargin : totalTopMargin;

    // console.log({ minTopMargin, maxTopMargin, totalTopMargin });

    this.setState({ topMargin: totalTopMargin });
  };

  render() {
    const { inputEmail, topMargin } = this.state;
    const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;

    const blurCardObj = localFakeBlurCardsRateJSON;

    const noOfResultBlurCards = noOfBlurCards(seaFCLJSON, seaLCLJSON, airJSON);

    return (
      <div
        ref={cardsRef}
        className="testR1"
        style={{
          position: 'relative',

          height: 'auto',
          ...(window.innerWidth >= 993
            ? {
                width: '675px',
              }
            : {
                maxWidth: '675px',
                width: '100%',
              }),
        }}
      >
        {/* array of blurry cards*/}
        {Array(noOfResultBlurCards)
          .fill()
          .map((_, index) => {
            return (
              <StyledCard
                key={index}
                style={{
                  // height: '100%',
                  width: '100%',
                  maxWidth: '675px',
                  height: '264px',
                  margin: '0px 0px 15px 0px',
                  padding: '0px',
                  borderRadius: '5px',
                  boxShadow: '0 1px 5px rgba(0, 0, 0, 0.15)',
                  background: 'white',
                  marginBottom: '15px',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'stretch',
                  }}
                >
                  {/* left side of card */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-between',
                      height: '100%',
                      maxWidth: '451px',
                      width: '100%',
                      border: '1px solid grey',
                    }}
                    className="testR1"
                  >
                    {/* top logo and company name */}
                    <div
                      className="testBlu1"
                      style={{
                        width: '100%',
                        height: '112px',
                        fontWeight: 'bolder',
                        display: 'flex',
                        justifyContent: 'start',
                        borderBottom: '1px solid grey',
                        padding: '4px',
                      }}
                    >
                      {/* company logo */}
                      <Avatar
                        shape="square"
                        size={48}
                        src={blurCardObj.avatar}
                        alt="company-logo"
                      />
                      <div
                        style={{
                          marginLeft: '8px',
                          color: 'black',
                          padding: '4px 0px',
                          maxWidth: '100%',
                          maxHeight: '100px',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                          flexWrap: 'wrap',
                        }}
                        className="testR1"
                      >
                        {/* company name */}
                        <span style={{ marginBottom: '24px' }}>
                          {blurCardObj.sealine}
                        </span>
                        {/* company desc */}
                        <span>{blurCardObj.description}</span>
                      </div>
                    </div>
                    {/* bottom route part */}
                    <div
                      className="testBlu1"
                      style={{
                        width: '100%',
                        maxWidth: '100%',
                        height: '85px',
                        padding: '10px',
                        fontSize: '14px',
                        fontWeight: 'bolder',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        flexWrap: 'wrap',
                        borderBottom: '1px solid grey',
                      }}
                    >
                      {/* origin */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            background: this.props.secondaryColor,
                          }}
                        ></span>
                        <span>{blurCardObj.port_of_origin}</span>
                      </div>

                      {/* horz. line */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          width: '50px',
                        }}
                      >
                        <div
                          style={{
                            maxWidth: '100%',
                            width: '100%',
                            background: this.props.secondaryColor,
                            height: '4px',
                          }}
                        ></div>
                        <span>&nbsp;</span>
                      </div>

                      {/* destination */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            background: this.props.secondaryColor,
                          }}
                        ></span>
                        <span>{blurCardObj.port_of_discharge.company_name}</span>
                      </div>

                      {/* horz. line */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          width: '50px',
                        }}
                      >
                        <div
                          style={{
                            maxWidth: '100%',
                            width: '100%',
                            background: this.props.secondaryColor,
                            height: '4px',
                          }}
                        ></div>
                        <span>&nbsp;</span>
                      </div>

                      {/* delivery */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            background: this.props.secondaryColor,
                          }}
                        ></span>
                        <span>{blurCardObj.port_of_discharge.company_name}</span>
                      </div>
                    </div>
                    {/* view-details */}
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        height: '30px',
                        color: 'var(--blueColor)',
                        fontWeight: 'bold',
                      }}
                      className="testO1"
                    >
                      View Details
                    </div>
                  </div>

                  {/* right side of card */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      maxWidth: '224px',
                      width: '100%',
                      border: '1px solid grey',
                      borderLeft: 'none',
                    }}
                    className="testR1"
                  >
                    {/* top company name */}
                    <div
                      className="testBlu1"
                      style={{
                        width: '100%',
                        height: '34px',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        fontWeight: 'bolder',
                        borderBottom: '1px solid grey',
                      }}
                    >
                      {/* company logo */}
                      <Avatar
                        shape="square"
                        size={24}
                        src={blurCardObj.avatar}
                        alt="company-logo"
                      />
                      <span>{blurCardObj.sealine}</span>
                    </div>
                    {/* no. of container */}
                    <div
                      className="testBlu1"
                      style={{
                        width: '100%',
                        height: '83px',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '8px',
                        fontWeight: 'bolder',
                        borderBottom: '1px solid grey',
                      }}
                    >
                      <span>20 Standard 1</span>
                      <span>40 Standard 1</span>
                      <span>40 High Cube 1</span>
                    </div>
                    {/* book now btn */}
                    <div
                      className="testBlu1"
                      style={{
                        width: '100%',
                        height: '110px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        size="large"
                        style={{
                          height: '65px',
                          maxWidth: '130px',
                          padding: '4px 26px 4px 26px',
                          border: 'none',
                          color: '#fff',
                          background: this.props.secondaryColor,
                          borderBottom: `2px solid rgba(128,128,128,0.9)`,
                          // boxShadow: "0px 0px 0px 2px rgba(0,0,0,0.3)",
                          fontSize: '16px',
                          borderRadius: '5px',
                        }}
                      >
                        <div>
                          <span style={{ fontSize: '16px', fontWeight: 600 }}>
                            {blurCardObj.bookNowPrice}
                          </span>
                          <div style={{ fontSize: '8px' }}>
                            {blurCardObj.currency}
                          </div>
                        </div>

                        <div>Book Now</div>
                      </Button>
                    </div>
                  </div>
                </div>
              </StyledCard>
            );
          })}

        {/* email input overlay */}
        {noOfResultBlurCards > 0 && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              // alignItems: 'center',
              paddingTop: `${topMargin}px`,
            }}
          >
            <div
              ref={emailFormRef}
              style={{
                margin: '0px 60px',
                width: '100%',
                height: '120px',
                background: this.props.primaryColor,
                display: 'inline-flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'start',
                padding: '14px',
                borderRadius: '14px',
                boxShadow: '2px 4px 5px #ccc',
                zIndex: 1,
              }}
              className="testBlu1"
            >
              {/* email label */}
              <div
                style={{
                  color: 'white',
                  fontWeight: 'bolder',
                  fontSize: '16px',
                  marginBottom: '8px',
                }}
              >
                {SEARCH_BLUR_CARDS_EMAIL_LABEL_TEXT}
              </div>
              {/* email input */}
              <div style={{ display: 'flex', width: '100%' }}>
                <Input
                  placeholder="Type your email"
                  value={inputEmail || ''}
                  style={{
                    borderRadius: '14px',
                    marginRight: '10px',
                    width: '100%',
                  }}
                  onPressEnter={this.onEnterClick}
                  onChange={this.onInputChange}
                  allowClear
                />
                <Button
                  style={{
                    borderRadius: '4px',
                    fontWeight: 'bolder',
                    fontSize: '14px',
                    color: this.props.primaryColor,
                  }}
                  onClick={this.onEnterClick}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

BlurCards.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,

  /**
   * Primary Color of the web app
   */
  primaryColor: PropTypes.string,

  /**
   * Secondary Color of the web app
   */
  secondaryColor: PropTypes.string,

  /**
   * It's the parent website scrollbar position.
   */
  parentScrollbarPosition: PropTypes.number,

  /**
   * It's value is flipped upon submitting postal codes,
   * so that pickup delivery ers line can re-render and prices will be updated.
   */
  updatePickupDeliveryErsLine: PropTypes.bool,

  /**
   * Email of the user
   */
  userEmailBlurCards: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    seaFCLJSON: state.route.seaFCLJSON,
    seaLCLJSON: state.route.seaLCLJSON,
    airJSON: state.route.airJSON,

    primaryColor: state.code_config.primaryColor,
    secondaryColor: state.code_config.secondaryColor,

    parentScrollbarPosition: state.code_config.parentScrollbarPosition,
    updatePickupDeliveryErsLine: state.route.updatePickupDeliveryErsLine,
    userEmailBlurCards: state.cache.userEmailBlurCards,
  };
};

export default connect(mapStateToProps, actions)(BlurCards);
